import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { history } from 'mobile_web/modules/navigation/history'
import { webHostToEnvironment } from 'mobile_web/modules/logging'
import App from './App.tsx'
import './index.css'

const environment = webHostToEnvironment()
if (environment !== 'development') {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.reactRouterV5BrowserTracingIntegration({ history }),
		],
		tracesSampleRate: 0.01,
		environment,
	})
}

createRoot(document.getElementById('root')!).render(<App />)
